import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { selectZone } from '../../../actions'

function Handle({
  domain: [min, max],
  handle: { id, value, percent },
  getHandleProps,
  label,
  onSelectSplit
}) {
  return (
    <div
      className={label}
      aria-valuemin={min}
      aria-valuemax={max}
      aria-valuenow={value}
      style={{
        left: `${percent}%`,
        position: 'absolute',
        marginLeft: '-11px',
        marginTop: '-8px',
        zIndex: 2,
        width: 20,
        height: 20,
        cursor: 'grabbing',
        borderRadius: '50%',
        borderWidth: '2px',
        borderStyle: 'solid',
        borderColor: label === 'A' ? '#04aef0' : '#9a6aad',
        backgroundColor: '#4a4a4a',
        boxShadow: '1px 1px 1px 1px rgba(0, 0, 0, 0.2)'
      }}
      {...getHandleProps(id)}
    />
  )
}

Handle.propTypes = {
  domain: PropTypes.array.isRequired,
  handle: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired,
  }).isRequired,
  getHandleProps: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSelectSplit: (value) => {
      dispatch(selectZone(value))
    }
  }
}

export default connect(null, mapDispatchToProps)(Handle)
